namespace GeniuzPOS.InitialData {
    export namespace PsConnectEdcBankService {
        export const baseUrl = 'InitialData/PsConnectEdcBank';

        export declare function Create(request: Serenity.SaveRequest<PsConnectEdcBankRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsConnectEdcBankRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsConnectEdcBankRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsConnectEdcBankRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsConnectEdcBank/Create",
            Update = "InitialData/PsConnectEdcBank/Update",
            Delete = "InitialData/PsConnectEdcBank/Delete",
            Retrieve = "InitialData/PsConnectEdcBank/Retrieve",
            List = "InitialData/PsConnectEdcBank/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsConnectEdcBankService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
